import { AfterContentInit, AfterViewInit, Component, ContentChildren, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { DataStateChangeEvent, GridComponent, PagerSettings, SelectionEvent, RowArgs, RowClassArgs, ColumnBase } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor, process, State } from '@progress/kendo-data-query';
import { Observable, Subscription } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';
import { TreeFilter } from '~/front-models/treeFilter';
import { treeFilterMapOptions } from '~/front-models/treeFilterMap';
import { whereFilterMapOptions } from '~/front-models/whereFilterMap';
import { ComponentBase } from '~/infrastructure/component-base';
import { augmentForKendo, DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldSummary } from '~/models/modules/gridField';
import { DocumentCreator } from '~/services/doc-generator';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { CsvDataService } from '~/services/saveCsvFile.service';
import { ExcelDataService } from '~/services/saveExcelFile.service';
import { GridLayoutManagerService } from './grid-layout-manager';
import { Packer } from 'docx';
import { saveAs } from '@progress/kendo-file-saver';
import { PageListColumnDirective } from './column';
import { DatePipe } from '@angular/common';
import { FormatService } from '~/services/administration.ts/format';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PaperSize } from '@progress/kendo-drawing/dist/npm/pdf';
import { SharedService } from '~/services/sharedService';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { SitesEnum } from '~/shared/enums/sites.enum';

@Component({
    selector: 'asap-grid-layout',
    templateUrl: './layout.html',
    styleUrls: ['./layout.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-grid-layout',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class GridLayoutComponent<T> extends ComponentBase implements OnInit, AfterViewInit, AfterContentInit, OnChanges, OnDestroy {
  _items: any;
  _selectedChangeList: any[] = [];
  _columns: PageListColumnDirective<T>[];
  _commandColumn: any = {};
  _gridColumns: GridFieldSummary[];
  _gridColumnsSelected: GridFieldSummary[];
  _customFieldsMode: boolean;
  _customFieldChanged: string;
  _customFieldInSorting: boolean;
  _customFieldInFilter: boolean;
  _selectedKeys: string[] = [];
  _selectableSettings: any = { checkboxOnly: true, mode: 'multiple', enabled: false };
  _deleted: boolean = false;
  _searchEnabled: boolean;
  _searchQuery: string;
  _scrollable: boolean;
  _groupingEnabled: boolean;
  _state: State = {
    skip: 0,
    take: 50,
    sort: [],
    group: [],
    filter: { logic: 'and', filters: [] }
  };

  _pageable: PagerSettings = {
    info: true,
    pageSizes: [50, 100, 150, 200, 250, 300],
    previousNext: true
  };

  _currentRow: Record<string, boolean> = {};
  _maxHeight: number;
  _selectedAccounts: any[] = [];
  _selectedItems: any[] = [];
  _columnsToShowFilterData: string[];
  _pdfColumns: { field: string; name: string; width: number }[] = [];
  isSearchMode: boolean = false;
  currentPage: number = 0;
  _currentUser: UserSummary;
  private _isLoadingData: boolean = false;
  private _lastLoadRequestKey: string = '';
  private _lastLoadTimestamp: number = 0;

  _paperSize: PaperSize = ['30in', '20in'];
  _pageScale: number = 1.0;
  //#region Asset Purchase Order Properties
  assetPurchaseOrderStatusId: any = 1; //Open Purchased Orders
  //#endregion
  @Input() page: string;
  @Input() exportFileName: string = '';
  @Input() entityName: string = 'Stock';
  @Input() selectable: boolean;
  @Input() singleSelect: boolean;
  @Input() pagingEnabled: boolean;
  @Input() sortingEnabled: boolean;
  @Input() headerEnable: boolean;
  @Input() importEnable: boolean;
  @Input() exportExcelEnable: boolean;
  @Input() exportPDFEnable: boolean;
  @Input() exportCSVEnabled: boolean;
  @Input() exportWordEnabled: boolean;
  @Input() orderEnable: boolean;
  @Input() actionEnabled: boolean;
  @Input() deletedEnabled: boolean = true;
  @Input() filteringEnable: boolean;
  @Input() graphEnabled: boolean;
  @Input() groupingEnabled: boolean = true;
  @Input() searchEnabled: boolean = true;
  @Input() DisableDestory: boolean = true;
  @Input() searchResult: string;
  @Input() addNewFormEnabled: boolean = true;
  @Input() showOnlySelected?: boolean = false;
  @Input() headerTitle: string;
  @Input() selectedKeys: any[] = [];
  @Input() returnedSelectedKeys: any[];
  @Input() selectByField: any;
  @Input() selectByFieldTitle: string;
  @Input() enableSiteSelection: boolean;
  @Input() DisableLoder: boolean = false;
  @Input() HideNotesFields: boolean = false;
  @Input() includeAllSites: boolean = true;
  @Input() resolver: (params?: any, model?: any) => Observable<any[] | DataWithPagingMetadata<any>>;
  @Input() data: any[];
  @Input() id: string = "";
  @Input() rowClass?: (context: RowClassArgs) => string;

  // _data: any[];
  // @Input()
  // set data(datainput: any[]){
  //   this._data = [...datainput];
  // }
  // get data():any[]{
  //   return this._data;
  // }
  @Input() isData: boolean = false;
  @Input() withHeader: boolean = true;
  @Input() refreshInitData: boolean;
  @Input() _inActiveMode: boolean = false;
  @Input() _assetPurchaseOrderStatusValue: any = null;
  @Input() _stockPurchaseOrderStatusValue: any = null;
  @Input() _stockSalesOrderStatusValue: any = null;
  @Input() _siteTransferStatusValue: any = null;
  @Input() assetReservationItemTypeValue: any = null;
  @Input() isAssetReservation: boolean = false;
  @Input() performMaintenanceItemTypeValue: any = null;
  @Input() isPerformMaintenance: boolean = false;
  @Input() disposeAuthorizationValue: any = { id: 1, code: 'Pending' };
  @Input() overridePage: string = '';
  @Input() _historyFilterValue: any = null;
  @Input() isHistoryPage: boolean = false;
  @Output() historyFilterValueEvent = new EventEmitter<any>();
  @Input() TransactionFire: boolean = false;
  @Input() _isClosed: boolean = false;
  @Input() canBatchReceive: boolean = false;
  @Input() canBatchMove: boolean = false;
  @Input() canBatchDispose: boolean = false;
  @Input() canBatchIssue: boolean = false;
  @Input() canBatchDeactivate: boolean;
  @Input() canBatchActivate: boolean;
  @Input() canBatchReactivate: boolean;
  @Input() canBatchApprove: boolean = false;
  @Input() canBatchReject: boolean = false;
  @Input() canBatchCheckOut: boolean = false;
  @Input() canBatchCheckIn: boolean = false;
  @Input() editColumnsEnabled: boolean = true;
  @Input() reloadDataEnabled: boolean = true;
  @Input() hiddenColumns: any = [];
  @Input() fromBarcodeLabel: any = false;
  @Input() clientSidePaging: boolean = false;

  @Output() onRowSelectionChanges: EventEmitter<any[]> = new EventEmitter();
  @Output() onRowObjectSelectionChanges: EventEmitter<any[]> = new EventEmitter();
  @Output() onGraphVisibilityChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() doubleClickEvent = new EventEmitter<any>();
  @Output() onActiveMode = new EventEmitter<boolean>();
  @Output() onClosedMode = new EventEmitter<boolean>();
  @Output() assetPurchaseOrderStatusValueEvent = new EventEmitter<any>();
  @Output() stockPurchaseOrderStatusValueEvent = new EventEmitter<any>();
  @Output() stockSalesOrderStatusValueEvent = new EventEmitter<any>();
  @Output() siteTransferStatusValueEvent = new EventEmitter<any>();
  @Output() assetReservationValueEvent = new EventEmitter<any>();
  @Output() performMaintenanceValueEvent = new EventEmitter<any>();
  @Output() disposeAuthorizationValueEvent = new EventEmitter<any>();
  @Output() onRowObjectSelectionindexList: EventEmitter<any[]> = new EventEmitter();
  @Output() batchActionClicked: EventEmitter<string> = new EventEmitter<string>();
  @ContentChildren(PageListColumnDirective) columns: QueryList<PageListColumnDirective<T>>;
  @ViewChild('gridWrapper') gridWrapper: ElementRef;
  @ViewChild('grid') grid: GridComponent;
  @ViewChild('grid_header_wrapper') gridHeaderWrapper: ElementRef;
  @ViewChildren('site_combobox') siteCombobox: QueryList<ComboBoxComponent>;
  @ViewChildren('columns') columnChildren: QueryList<ColumnBase>;
  IsFirstChange: boolean = true;
  ColumnSubscription: Subscription;

  constructor(private _gridLayoutManagerService: GridLayoutManagerService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _ngZone: NgZone,
    private _csvFile: CsvDataService,
    private _excelFile: ExcelDataService,
    private _formatService: FormatService,
    private _securityService: SecurityService,
    private _sharedService: SharedService) {
    super();
    this._currentUser = this._securityService.currentUser;
    this._currentUser = this._securityService.currentUser;
    this._exportPdfData = this._exportPdfData.bind(this);
  }

  GridFieldsSubscription: Subscription;

  ngOnInit() {
    //this._gridLayoutManagerService.destroy();
    if (this.exportFileName == '') {
      this.exportFileName = this.page;
    }

    this._securityService.getLicenseObservable().subscribe((l: any) => {
      const general = l?.licenses?.general;
      if (general && !general.excelImport && !general.textImport) {
        this.importEnable = false;
      }
    });

    if ((this.page == 'siteTransfers' || this.page == 'site-transfers') && (this._siteTransferStatusValue === null || this._siteTransferStatusValue === undefined)) {
      this._siteTransferStatusValue = '1';
    }

    this._searchEnabled = this.headerEnable;
    this._sharedService.onDeleteFromGrid.subscribe(x => {
      this.initData(false, true);
    });

    this.LoadingDataAfterActivate = this._sharedService.ActivateOrDeactivate.subscribe((x: any) => {
      if (x) {
        this._selectedKeys = [];
        this._selectedItems = [];
        this.onRowSelectionChanges.emit(this._selectedKeys);
        this.onRowObjectSelectionChanges.emit(this._selectedItems);
        this._lastLoadRequestKey = '';
        this.initData();
      }
    });
    // if(this.GridFieldsSubscription)
    // this.GridFieldsSubscription.unsubscribe();
    // this.GridFieldsSubscription = this._gridFields
    // .getGridFieldsByPage(this.page)
    // }
    // this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges(this.page, (gridColumns) => {
    //   this._gridColumns = gridColumns;
    // }));
  }

  ngAfterViewInit() { }

  ngAfterContentInit() {
    if (this.canBatchActivate === undefined) this.canBatchActivate = true;

    if (this.selectable && this.page !== 'pickList' && !this.canBatchDeactivate && !this.canBatchReceive && !this.canBatchActivate && !this.canBatchMove
      && !this.canBatchDispose && !this.canBatchIssue && !this.canBatchApprove && !this.canBatchReject
      && !this.canBatchCheckOut && !this.canBatchCheckIn) {
      this.selectable = false;
    }

    if (this.selectable) {
      this._selectableSettings['enabled'] = true;

      if (this.singleSelect) {
        this._selectableSettings['mode'] = 'single';
      }
    }

    if (this.headerEnable)      //&& this.groupingEnabled
    {
      if (this.ColumnSubscription) {
        this.ColumnSubscription.unsubscribe();
      }

      this.registerSubscription(this.ColumnSubscription = this._gridLayoutManagerService.subscribeToColumnsChanges(this.page, (gridColumns) => {
        //var i = 0;

        if (gridColumns && gridColumns.length) {
          this._gridColumns = gridColumns;
          let Page_Name = this._gridColumns.map((a: any) => a.page).shift();
          let pageSize = this._sharedService.getPageSize(this._currentUser.id, Page_Name)
          if (pageSize) {
            this._state.take = parseInt(pageSize)
          }
          this._gridColumnsSelected = gridColumns.filter((f) => f.selected == true);
          // if(this.addNewFormEnabled
          //   || (!this.addNewFormEnabled && ))
          //this._gridLayoutManagerService.destroy();
          //if(i == 0)
          this.initGrid();

          //this.FirstTimeFetchAll = true;
        }
        // else
        // {

        //   if(!this.addNewFormEnabled && gridColumns != null)
        //   {
        //     this.FirstTimeFetchAll = false;
        //     this.initGrid();
        //   }
        // }
      }));

    }
    else {
      this.initGrid();
    }

    if (this.columns) {
      this.registerSubscription(this.columns.changes.subscribe(() => {
        this.initGrid();
      }));
    }
    // if(!this._gridColumns
    //   || (this._gridColumns && this._gridColumns.length == 0)
    //   )
    // {
    //   if(this.GridFieldsSubscription)
    //   this.GridFieldsSubscription.unsubscribe();
    //   this.GridFieldsSubscription = this._gridFields
    //   .getGridFieldsByPage(this.page)
    //   
    //   .subscribe((data: any) => {
    //     this._gridLayoutManagerService.setGridColumnSubjects(this.page, data);
    //     this._gridColumns = data;
    //     this.initGrid();
    //   });

    // }
    if (this.columns && this.columns.length > 0 && !this._gridColumns) {

      if (this.GridFieldsSubscription) {
        this.GridFieldsSubscription.unsubscribe();
      }

      this.GridFieldsSubscription = this._gridFields.getGridFieldsByPage(this.page).subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this.page, data);
        // this._gridColumns = data;
        // this.initGrid();
      });
    }

    if (this.page) {
      this.registerSubscription(this._gridLayoutManagerService.subscribeToDataChanges(this.page, (x) => {
        this._lastLoadRequestKey = '';
        this.initData();
      }));
    }
  }

  LoadingDataAfterActivate: Subscription
  IsCalledFromOnChanges: boolean = false;
  IsCalledAfterDataChangesSubscription: boolean = false;
  FirstTimeFetchAll: boolean = true;

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.returnedSelectedKeys && !changes.returnedSelectedKeys.firstChange)
      || (changes.refreshInitData && !changes.refreshInitData.firstChange)
      || (changes.hiddenColumns && !changes.hiddenColumns.firstChange)) {    //||    //changes
      this.IsCalledFromOnChanges = true;

      setTimeout(() => {

        // if(!this._gridColumns)
        // {
        this.initGrid(true);
        //}
      }, 30)

      // else
      // {
      //   this.FirstTimeFetchAll = true;
      // }


      return;
    }


    if (changes.data || changes.isData) {
      this.initData();
    }

    if (changes.searchResult) {
      if (this.searchResult) {
        this._searchEnabled = true;
      }
      //this.IsFirstChange = false;
      this.IsCalledFromOnChanges = true;
      this._onSearch(this.searchResult);

      return;
    }

    this.IsCalledFromOnChanges = false;
  }

  ngOnDestroy() {
    if (this.headerEnable && this.groupingEnabled) {     //&& this.DisableDestory
      this._gridLayoutManagerService.destroy();
    }

    if (this.ColumnSubscription) {
      this.ColumnSubscription.unsubscribe();
    }

    if (this.LoadingDataAfterActivate) {
      this.LoadingDataAfterActivate.unsubscribe();
    }
  }
  // exportToExcel() {
  //   // this.TestGrid = this.grid;
  //   // this.TestGrid.data.data = this.TestGrid.data.data.filter((x: any) => x.id == 1010)
  //   this.grid.saveAsExcel();
  // }

  dateattribute(searchkey: any) {
    let datetypeattrabuit = this._gridColumns.filter((a: any) => a.type === 'date');

    let isexist = datetypeattrabuit.find((a: any) => a.field === searchkey);

    if (isexist !== undefined) {
      let objecttype = this._gridColumns.find((a: any) => a.field === searchkey).type;

      if (objecttype !== undefined && objecttype !== null && objecttype === 'date') {
        return true;
      }
    }

    return false;
  }

  poApprovalSiteAttribute(searchkey: any) {
    let siteAttribute = this._gridColumns.find((a: any) => a.field === 'poApprovalSites.site.name');

    if (siteAttribute.field == searchkey) {
      return true;
    }
  }
  isPDF: boolean = false;
  exportToExcel(exportpdft: boolean = false) {
    this.isPDF = exportpdft;
    const datepipe: DatePipe = new DatePipe('en-US');

    this._exportData().subscribe((data) => {
      data.data.value = data.data.value ?? data.data;

      const modelParam = this._getParamModel(false);
      const modelFilter = this.filteringEnable ? this._getFilterModel() : {};
      var itemKeys = null;

      if (!this._customFieldsMode) {
        itemKeys = data.data.value.map((x: any) => x.id);
      }

      let model: any = { filter: modelFilter, entityIds: itemKeys, entity: this.entityName, page: this.page };

      if (this.page == 'poApprovals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', siteName: '', vendorName: '' });

          this._items.data = data.data.value;
        }
      }
      else if (this.page == 'asset-po-approvals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', siteName: '', vendorName: '' });

          this._items.data = data.data.value;
        }
      }
      else if (this.page == 'soApprovals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', soSiteName: '', customerName: '' });

          this._items.data = data.data.value;
        }
      }
      else if (this.page == "persons") {
        for (var i = 0; i < data.data.value.length; i++) {
          this.GetPrimaryManagerData(data.data.value[i]?.managers, data.data.value[i]);
          this.GetPrimaryDepartmentData(data.data.value[i]?.personDepartments, data.data.value[i]);
        }
        //this._items.data = data.data.value;
      }
      else if (this.page == "moveHistory") {

        for (let i = 0; i < data.data.value.length; i++) {

          const item = data.data.value[i];

          if (item.stock) {
            const cost = item.stock?.costInfo?.cost;
            const receiveMultiplier = item.stock?.receiveUnitOfMeasure?.multiplier;
            const inventoryMultiplier = item.stock?.inventoryUnitOfMeasure?.multiplier;
            const quantity = item.quantityMoved;
            const fixedUnitPriceData = item.stock?.costInfo?.fixedUnitPrice;
            const markupPercent = item.stock?.costInfo?.markupPercent;
            const markupNumber = item.stock?.costInfo?.markupNumber;

            let extendedCost = (cost / receiveMultiplier) * inventoryMultiplier * quantity;
            let inventoryCost = (cost / receiveMultiplier) * inventoryMultiplier;

            let fixedUnitPriceextended = (fixedUnitPriceData != 0 && fixedUnitPriceData != null) ? fixedUnitPriceData * (quantity / inventoryMultiplier) :
              (((cost / receiveMultiplier) *
                inventoryMultiplier) *
                ((markupPercent + 1) + (markupNumber + 1))) * (quantity / inventoryMultiplier);

            let fixedUnitPrice = (fixedUnitPriceData != 0 && fixedUnitPriceData != null) ? fixedUnitPriceData :
              ((cost / receiveMultiplier) *
                inventoryMultiplier) *
              ((markupPercent + 1) + (markupNumber + 1));


            item.stock.extendedCost = isNaN(extendedCost) ? '' : extendedCost;
            item.stock.inventoryCost = isNaN(inventoryCost) ? '' : inventoryCost;
            if (item.stock.costInfo) {
              item.stock.costInfo.fixedUnitPriceextended = isNaN(fixedUnitPriceextended) ? '' : fixedUnitPriceextended;
              item.stock.costInfo.fixedUnitPrice = isNaN(fixedUnitPrice) ? '' : fixedUnitPrice;
            }

          }

        }

        this._items.data = data.data.value;

      } else if (this.page == "adjustInventoryHistory") {
        for (let i = 0; i < data.data.value.length; i++) {

          const item = data.data.value[i];

          if (item.stock.costInfo) {
            const fixedUnitPrice = item.stock?.costInfo?.fixedUnitPrice;
            const receiveMultiplier = item.stock?.receiveUnitOfMeasure?.multiplier;
            const inventoryMultiplier = item.stock?.inventoryUnitOfMeasure?.multiplier;
            const issueUnitOfMeasure = item.stock?.issueUnitOfMeasure?.multiplier;
            const markupPercent = item.stock?.costInfo?.markupPercent;
            const markupNumber = item.stock?.costInfo?.markupNumber;
            const newQuantity = item.newQuantity;
            const currentQuantity = item.currentQuantity;
            let quantityChange = Math.abs(newQuantity - currentQuantity);
            const cost = item.stock?.costInfo?.cost;
            let extendedCost = ((cost / receiveMultiplier) * issueUnitOfMeasure) * Math.abs(newQuantity - currentQuantity)
            let inventoryCost = ((cost / receiveMultiplier) * issueUnitOfMeasure);


            let price = fixedUnitPrice ? fixedUnitPrice : ((cost / receiveMultiplier) * inventoryMultiplier) * (1 + markupPercent ? markupPercent : 0) + (markupNumber ? markupNumber : 0);
            let extendedPrice = fixedUnitPrice ? fixedUnitPrice : ((cost / receiveMultiplier) * inventoryMultiplier) * (1 + markupPercent ? markupPercent : 0) + (markupNumber ? markupNumber : 0) * newQuantity / inventoryMultiplier;



            item.stock.costInfo.price = isNaN(price) ? 0 : price;
            item.stock.costInfo.extendedPrice = isNaN(extendedPrice) ? 0 : extendedPrice;
            item.stock.costInfo.extendedCost = isNaN(extendedCost) ? 0 : extendedCost;
            item.quantityChange = quantityChange;
            item.stock.costInfo.inventoryCost = isNaN(inventoryCost) ? 0 : extendedCost;

          }

        }

        this._items.data = data.data.value;
      } else if (this.page == 'inventories' || this.page == 'enterprise_inventories') {
        for (let i = 0; i < data.data.value.length; i++) {
          const item = data.data.value[i];
          if (item.stockItem) {
            const cost = item.stockItem?.costInfo?.cost ?? 0;
            const receiveMultiplier = item.stockItem?.receiveUnitOfMeasure?.multiplier ?? 1;
            const inventoryMultiplier = item.stockItem?.inventoryUnitOfMeasure?.multiplier ?? 1;
            const availability = item.availability ?? 0;

            let inventoryCost = (cost / (receiveMultiplier || 1)) * inventoryMultiplier;
            let extendedCost = inventoryCost * availability;

            item.stock = {
              inventoryCost: isNaN(inventoryCost) ? '' : inventoryCost,
              extendedCost: isNaN(extendedCost) ? '' : extendedCost
            };
          }
        }
        this._items.data = data.data.value;
      }
      else {
        this._items.data = data.data.value;
      }

      this.resolveAndMapNestedColumns(data.data.value);

      if (this._customFieldsMode) {
        model['selectedField'] = this._customFieldChanged;
        modelParam.orderBy = 'value';
      }

      this._customFieldsService.getEntityData(modelParam, model).pipe(map(augmentForKendo)).subscribe((customFieldsData: any) => {
        this.syncCustomFieldsDataWithDefaultData(customFieldsData, data, exportpdft);

        try {
          this._items.data.forEach((element: any) => {
            for (const k in element) {
              if (element[k] !== null) {
                try {
                  if (this.dateattribute(k)) {
                    element[k] = datepipe.transform(element[k], this._formatService.dateFormat);
                  }

                  if (this.page == 'poApprovals') {
                    if (k == 'approvalLevel') {
                      element[k] = element?.poApprovalDetails.length;
                    }

                    if (k == 'siteName') {
                      var sites: string = '';

                      element.poApprovalSites.forEach((elem: any) => {
                        if (element.poApprovalSites.indexOf(elem) == 0) {
                          sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                        }
                        else {
                          sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                        }
                      });

                      element[k] = sites;
                    }

                    if (k == 'vendorName') {
                      var vendors: string = '';

                      element.poApprovalSites.forEach((eleme: any) => {
                        eleme.poVendorApprovals.forEach((vendor: any) => {
                          if (vendor && vendor.vendor && vendor.vendor.code && vendor.vendor.code.length > 0) {
                            if (!vendors) {
                              vendors = vendors + vendor.vendor.code;
                            }
                            else {
                              vendors = vendors + ',' + vendor.vendor.code;
                            }
                          }
                        });
                      });

                      element[k] = vendors;
                    }
                  }

                  if (this.page == 'asset-po-approvals') {
                    if (k == 'approvalLevel') {
                      element[k] = element?.assetPurchaseOrderApprovalDetails.length;
                    }

                    if (k == 'siteName') {
                      var sites: string = '';

                      element.assetPurchaseOrderApprovalSites.forEach((elem: any) => {
                        if (element.assetPurchaseOrderApprovalSites.indexOf(elem) == 0) {
                          sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                        }
                        else {
                          sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                        }
                      });

                      element[k] = sites;
                    }

                    if (k == 'vendorName') {
                      var vendors: string = '';

                      element.assetPurchaseOrderApprovalSites.forEach((eleme: any) => {
                        eleme.assetPurchaseOrderVendorApprovals.forEach((vendor: any) => {
                          if (vendor && vendor.vendor && vendor.vendor.code && vendor.vendor.code.length > 0) {
                            if (!vendors) {
                              vendors = vendors + vendor.vendor.code;
                            }
                            else {
                              vendors = vendors + ',' + vendor.vendor.code;
                            }
                          }
                        });
                      });

                      element[k] = vendors;
                    }
                  }

                  if (this.page == 'soApprovals') {
                    if (k == 'approvalLevel') {
                      element[k] = element?.soApprovalDetails.length;
                    }

                    if (k == 'soSiteName') {
                      var sites: string = '';

                      element.soApprovalSites.forEach((elem: any) => {
                        if (element.soApprovalSites.indexOf(elem) == 0) {
                          sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                        }
                        else {
                          sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                        }
                      });

                      element[k] = sites;
                    }

                    if (k == 'customerName') {
                      var customers: string = '';
                      element.soApprovalSites.forEach((eleme: any) => {
                        eleme.soCustomerApprovals.forEach((customer: any) => {
                          {
                            if (!customers) {
                              customers = customers + customer.customer.code;
                            }
                            else {
                              customers = customers + ',' + customer.customer.code;
                            }
                          }
                        });
                      });

                      element[k] = customers;
                    }
                  }
                }
                catch (error) {
                  element[k] = element[k];
                }

                if (Object.keys(element[k]).length > 1) {
                  Object.keys(element[k]).forEach((key) => {
                    if (this.dateattribute([k] + '.' + [key])) {
                      element[k][key] = datepipe.transform(element[k][key], this._formatService.dateFormat);
                    }
                  });
                }
              }
            }
          });
        }
        catch (error) { }

        if (!exportpdft) {
          if (this.page == "persons") {
            this.ExcelFileData = data.data.value;
          }
          else {
            this.ExcelFileData = this._items.data;
          }

          this._excelFile.exportToExcel(this.headerTitle + '.xlsx', this.ExcelFileData, this._gridColumns, this._columns);
        }
        else {
          if (this.page == "persons") {
            this.PDFFileData = data.data.value;

            var PdfData = { data: data.data.value, total: this._items.total }

            this.grid.data = data.data.value;

            this.grid.saveAsPDF();
            this.grid.data = PdfData;
          } else {
            this.PDFFileData = this._items.data;

            var PdfData = { data: this._items.data, total: this._items.total }

            this.grid.data = this._items.data;

            this.grid.saveAsPDF();
            this.grid.data = PdfData;
          }
        }
      });
    });
  }

  exportToPDF() {
    const result: ExcelExportData = {
      // data: process(products, {
      //   group: this.group,
      //   sort: [{ field: "ProductID", dir: "asc" }],
      // }).data,
      // group: this.group,
      data: this.ExcelFileData,
    };
    //const oldColums = this._columns;
    //this._columns = this._columns.filter(c => c.name !== "Command" && c.name !== "Actions");
    //const oldSelecable = this.selectable;
    //this.selectable = false;
    this.grid.saveAsPDF();
    /*
    this.grid.drawPDF().then((groups) => {
      const rootGroup = new Group({
        pdf: {
          multiPage: true,
        },
      });
      // groups.forEach((group: { children: any; }) => {
        rootGroup.append(...groups.children);
      //});

      return exportPDF(rootGroup, { paperSize: "A4" });
    })
    .then((dataUri) => {
      saveAs(dataUri, "MultipleGrids.pdf");
    });
    */
    // this.grid.dataStateChange.subscribe(x => {
    //   //this.selectable = oldSelecable;
    //   this._columns = oldColums;
    // })
  }

  exportToCsv() {
    this._exportData().subscribe((data) => {
      data.data.value = data.data.value ?? data.data;
      //let itms: any = data.data.value;
      //this.loadCustomFieldData(data);
      //let itms: any = this.testGrid.data;

      const modelParam = this._getParamModel(false);
      const modelFilter = this.filteringEnable ? this._getFilterModel() : {};
      var itemKeys = null;

      if (!this._customFieldsMode) {
        itemKeys = data.data.value.map((x: any) => x.id);
      }

      let model: any = {
        filter: modelFilter,
        entityIds: itemKeys,
        entity: this.entityName,
        page: this.page,
        action: false,
      };

      if (this.page == 'poApprovals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', siteName: '', vendorName: '' });
          this._items.data = data.data.value;
        }
      }

      if (this.page == 'asset-po-approvals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', siteName: '', vendorName: '' });
          this._items.data = data.data.value;
        }
      }

      if (this.page == 'soApprovals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', soSiteName: '', customerName: '' });

          this._items.data = data.data.value;
        }
      }

      if (this.page == "persons") {
        for (var i = 0; i < data.data.value.length; i++) {

          this.GetPrimaryManagerData(data.data.value[i]?.managers, data.data.value[i]);
          this.GetPrimaryDepartmentData(data.data.value[i]?.personDepartments, data.data.value[i]);
        }
        //this._items.data = data.data.value;

      }


      if (this.page == "moveHistory") {

        for (let i = 0; i < data.data.value.length; i++) {
          const item = data.data.value[i];

          if (item.stock) {
            const cost = item.stock?.costInfo?.cost;
            const receiveMultiplier = item.stock?.receiveUnitOfMeasure?.multiplier;
            const inventoryMultiplier = item.stock?.inventoryUnitOfMeasure?.multiplier;
            const quantity = item.quantityMoved;
            const fixedUnitPriceData = item.stock?.costInfo?.fixedUnitPrice;
            const markupPercent = item.stock?.costInfo?.markupPercent;
            const markupNumber = item.stock?.costInfo?.markupNumber;

            let extendedCost = (cost / receiveMultiplier) * inventoryMultiplier * quantity;
            let inventoryCost = (cost / receiveMultiplier) * inventoryMultiplier;

            let fixedUnitPriceextended = (fixedUnitPriceData != 0 && fixedUnitPriceData != null) ? fixedUnitPriceData * (quantity / inventoryMultiplier) :
              (((cost / receiveMultiplier) *
                inventoryMultiplier) *
                ((markupPercent + 1) + (markupNumber + 1))) * (quantity / inventoryMultiplier);

            let fixedUnitPrice = (fixedUnitPriceData != 0 && fixedUnitPriceData != null) ? fixedUnitPriceData :
              ((cost / receiveMultiplier) *
                inventoryMultiplier) *
              ((markupPercent + 1) + (markupNumber + 1));


            item.stock.extendedCost = isNaN(extendedCost) ? '' : extendedCost;
            item.stock.inventoryCost = isNaN(inventoryCost) ? '' : inventoryCost;
            if (item.stock.costInfo) {
              item.stock.costInfo.fixedUnitPriceextended = isNaN(fixedUnitPriceextended) ? '' : fixedUnitPriceextended;
              item.stock.costInfo.fixedUnitPrice = isNaN(fixedUnitPrice) ? '' : fixedUnitPrice;
            }

          }

        }

        this._items.data = data.data.value;

      } else if (this.page == "adjustInventoryHistory") {
        for (let i = 0; i < data.data.value.length; i++) {

          const item = data.data.value[i];

          if (item.stock.costInfo) {
            const fixedUnitPrice = item.stock?.costInfo?.fixedUnitPrice;
            const receiveMultiplier = item.stock?.receiveUnitOfMeasure?.multiplier;
            const inventoryMultiplier = item.stock?.inventoryUnitOfMeasure?.multiplier;
            const issueUnitOfMeasure = item.stock?.issueUnitOfMeasure?.multiplier;
            const markupPercent = item.stock?.costInfo?.markupPercent;
            const markupNumber = item.stock?.costInfo?.markupNumber;
            const newQuantity = item.newQuantity;
            const currentQuantity = item.currentQuantity;
            let quantityChange = Math.abs(newQuantity - currentQuantity);
            const cost = item.stock?.costInfo?.cost;
            let extendedCost = ((cost / receiveMultiplier) * issueUnitOfMeasure) * Math.abs(newQuantity - currentQuantity)
            let inventoryCost = ((cost / receiveMultiplier) * issueUnitOfMeasure);


            let price = fixedUnitPrice ? fixedUnitPrice : ((cost / receiveMultiplier) * inventoryMultiplier) * (1 + markupPercent ? markupPercent : 0) + (markupNumber ? markupNumber : 0);
            let extendedPrice = fixedUnitPrice ? fixedUnitPrice : ((cost / receiveMultiplier) * inventoryMultiplier) * (1 + markupPercent ? markupPercent : 0) + (markupNumber ? markupNumber : 0) * newQuantity / inventoryMultiplier;



            item.stock.costInfo.price = isNaN(price) ? 0 : price;
            item.stock.costInfo.extendedPrice = isNaN(extendedPrice) ? 0 : extendedPrice;
            item.stock.costInfo.extendedCost = isNaN(extendedCost) ? 0 : extendedCost;
            item.quantityChange = quantityChange;
            item.stock.costInfo.inventoryCost = isNaN(inventoryCost) ? 0 : extendedCost;

          }

        }

        this._items.data = data.data.value;
      } else if (this.page == 'inventories' || this.page == 'enterprise_inventories') {
        for (let i = 0; i < data.data.value.length; i++) {
          const item = data.data.value[i];
          if (item.stockItem) {
            const cost = item.stockItem?.costInfo?.cost ?? 0;
            const receiveMultiplier = item.stockItem?.receiveUnitOfMeasure?.multiplier ?? 1;
            const inventoryMultiplier = item.stockItem?.inventoryUnitOfMeasure?.multiplier ?? 1;
            const availability = item.availability ?? 0;

            let inventoryCost = (cost / (receiveMultiplier || 1)) * inventoryMultiplier;
            let extendedCost = inventoryCost * availability;

            item.stock = {
              inventoryCost: isNaN(inventoryCost) ? '' : inventoryCost,
              extendedCost: isNaN(extendedCost) ? '' : extendedCost
            };
          }
        }
        this._items.data = data.data.value;
      }

      this.resolveAndMapNestedColumns(data.data.value);


      if (this._customFieldsMode) {
        model['selectedField'] = this._customFieldChanged;
        modelParam.orderBy = 'value';
      }

      this._customFieldsService.getEntityData(modelParam, model).pipe(map(augmentForKendo)).subscribe((customFieldsData: any) => {
        this.syncCustomFieldsDataWithDefaultData(customFieldsData, data);
        const datepipe: DatePipe = new DatePipe('en-US');
        let itms: any = data.data.value;

        if (itms && itms.length > 0) {
          const items: any[] = [];

          itms.forEach((element: any) => {
            for (const k in element) {
              if (element[k] !== null) {
                try {
                  if (this.dateattribute(k)) {
                    element[k] = datepipe.transform(element[k], this._formatService.dateFormat);
                  }

                  if (this.page == 'poApprovals') {
                    if (k == 'approvalLevel') {
                      element[k] = element?.poApprovalDetails.length;
                    }

                    if (k == 'siteName') {
                      var sites: string = '';
                      element.poApprovalSites.forEach((elem: any) => {
                        if (element.poApprovalSites.indexOf(elem) == 0) {
                          sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                        }
                        else {
                          sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                        }
                      });

                      element[k] = sites;
                    }

                    if (k == 'vendorName') {
                      var vendors: string = '';
                      element.poApprovalSites.forEach((eleme: any) => {
                        eleme.poVendorApprovals.forEach((vendor: any) => {
                          if (vendor && vendor.vendor && vendor.vendor.code && vendor.vendor.code.length > 0) {
                            if (!vendors) {
                              vendors = vendors + vendor.vendor.code;
                            }
                            else {
                              vendors = vendors + ',' + vendor.vendor.code;
                            }
                          }
                        });
                      });

                      element[k] = vendors;
                    }
                  }

                  if (this.page == 'asset-po-approvals') {
                    if (k == 'approvalLevel') {
                      element[k] = element?.assetPurchaseOrderApprovalDetails.length;
                    }

                    if (k == 'siteName') {
                      var sites: string = '';
                      element.assetPurchaseOrderApprovalSites.forEach((elem: any) => {
                        if (element.assetPurchaseOrderApprovalSites.indexOf(elem) == 0) {
                          sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                        }
                        else {
                          sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                        }
                      });

                      element[k] = sites;
                    }

                    if (k == 'vendorName') {
                      var vendors: string = '';
                      element.assetPurchaseOrderApprovalSites.forEach((eleme: any) => {
                        eleme.assetPurchaseOrderVendorApprovals.forEach((vendor: any) => {
                          if (vendor && vendor.vendor && vendor.vendor.code && vendor.vendor.code.length > 0) {
                            if (!vendors) {
                              vendors = vendors + vendor.vendor.code;
                            }
                            else {
                              vendors = vendors + ',' + vendor.vendor.code;
                            }
                          }
                        });
                      });

                      element[k] = vendors;
                    }
                  }

                  if (this.page == 'soApprovals') {
                    if (k == 'approvalLevel') {
                      element[k] = element?.soApprovalDetails.length;
                    }

                    if (k == 'soSiteName') {
                      var sites: string = '';
                      element.soApprovalSites.forEach((elem: any) => {
                        if (element.soApprovalSites.indexOf(elem) == 0) {
                          sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                        }
                        else {
                          sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                        }
                      });

                      element[k] = sites;
                    }

                    if (k == 'customerName') {
                      var customers: string = '';
                      element.soApprovalSites.forEach((eleme: any) => {
                        eleme.soCustomerApprovals.forEach((customer: any) => {
                          {
                            if (!customers) {
                              customers = customers + customer.customer.code;
                            }
                            else {
                              customers = customers + ',' + customer.customer.code;
                            }
                          }
                        });
                      });

                      element[k] = customers;
                    }

                    if (Object.keys(element[k]).length > 1) {
                      Object.keys(element[k]).forEach((key) => {
                        if (this.dateattribute([k] + '.' + [key])) {
                          element[k][key] = datepipe.transform(
                            element[k][key],
                            this._formatService.dateFormat
                          );
                        }
                      });
                    }
                  }
                }
                catch (error) {
                  element[k] = element[k];
                }
              }
            }

            const copy: any = {};
            Object.assign(copy, element);
            items.push(copy);
          });

          this._csvFile.exportToCsv(this.headerTitle + '.csv', items, this._gridColumns, this._columns);
        }
        else {
          const items: any[] = [];
          var dummyRecord: any = {};

          this._columns.forEach((col) => {
            dummyRecord[col.field] = '';
          });

          items.push(dummyRecord);
          this._csvFile.exportToCsv(this.headerTitle + '.csv', items, this._gridColumns, this._columns);

          /* this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'There is no data to export to CSV',
              withoutConfirm: true
            }); */
        }
      });
    });
  }

  // exportToWord() {
  //   this._exportData().subscribe(data => {
  //     data.data.value = data.data.value ?? data.data;
  //     const documentCreator = new DocumentCreator();
  //     const doc = documentCreator.createGrid(this.headerTitle, data.data.value, this._gridColumns);

  //           Packer.toBlob(doc).then(blob => {
  //             saveAs(blob, `${this.headerTitle}.docx`);
  //           });
  //       });

  //   }

  GetPrimaryManagerData(Managers: any, data: any) {
    if (Managers && Managers.length > 0) {
      let PrimaryManager: any = Managers.find((x: any) => x.isPrimary == true);

      if (PrimaryManager && PrimaryManager.manager) {
        data.managers = {
          manager: {
            code: PrimaryManager.manager.code,
            firstName: PrimaryManager.manager.firstName,
            lastName: PrimaryManager.manager.lastName,
          }
        }

        return;
      }
    }

    data.managers = {
      manager: {
        code: "",
        firstName: "",
        lastName: "",
      }
    }

  }

  GetPrimaryDepartmentData(PersonDepartments: any, data: any) {
    if (PersonDepartments && PersonDepartments.length > 0) {
      let PrimaryDepartment = PersonDepartments.find((x: any) => x.isPrimary == true);

      if (PrimaryDepartment && PrimaryDepartment.department) {
        data.personDepartments = {
          department: {
            code: PrimaryDepartment.department.code,
            name: PrimaryDepartment.department.name,
          }
        }

        return;
      }
    }

    data.personDepartments = {
      department: {
        code: "",
        name: "",
      }
    }
  }

  exportToWord() {
    this._exportData().subscribe((data) => {
      data.data.value = data.data.value ?? data.data;
      const modelParam = this._getParamModel(false);
      const modelFilter = this.filteringEnable ? this._getFilterModel() : {};
      var itemKeys = null;

      if (!this._customFieldsMode) {
        itemKeys = data.data.value.map((x: any) => x.id);
      }

      let model: any = {
        filter: modelFilter,
        entityIds: itemKeys,
        entity: this.entityName,
        page: this.page,
      };

      if (this._customFieldsMode) {
        model['selectedField'] = this._customFieldChanged;
        modelParam.orderBy = 'value';
      }

      if (this.page == 'poApprovals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', siteName: '', vendorName: '' });
          this._items.data = data.data.value;
        }
      }

      if (this.page == 'asset-po-approvals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', siteName: '', vendorName: '' });

          this._items.data = data.data.value;
        }
      }

      if (this.page == 'soApprovals') {
        for (var i = 0; i < data.data.value.length; i++) {
          // merge objects into one with multiple props
          data.data.value[i] = Object.assign(data.data.value[i], { approvalLevel: '', soSiteName: '', customerName: '' });
          this._items.data = data.data.value;
        }
      }

      if (this.page == "persons") {
        for (var i = 0; i < data.data.value.length; i++) {
          this.GetPrimaryManagerData(data.data.value[i]?.managers, data.data.value[i]);
          this.GetPrimaryDepartmentData(data.data.value[i]?.personDepartments, data.data.value[i]);
        }
        //this._items.data = data.data.value;
      }

      if (this.page == "moveHistory") {

        for (let i = 0; i < data.data.value.length; i++) {

          const item = data.data.value[i];

          if (item.stock) {
            const cost = item.stock?.costInfo?.cost;
            const receiveMultiplier = item.stock?.receiveUnitOfMeasure?.multiplier;
            const inventoryMultiplier = item.stock?.inventoryUnitOfMeasure?.multiplier;
            const quantity = item.quantityMoved;
            const fixedUnitPriceData = item.stock?.costInfo?.fixedUnitPrice;
            const markupPercent = item.stock?.costInfo?.markupPercent;
            const markupNumber = item.stock?.costInfo?.markupNumber;

            let extendedCost = (cost / receiveMultiplier) * inventoryMultiplier * quantity;
            let inventoryCost = (cost / receiveMultiplier) * inventoryMultiplier;

            let fixedUnitPriceextended = (fixedUnitPriceData != 0 && fixedUnitPriceData != null) ? fixedUnitPriceData * (quantity / inventoryMultiplier) :
              (((cost / receiveMultiplier) *
                inventoryMultiplier) *
                ((markupPercent + 1) + (markupNumber + 1))) * (quantity / inventoryMultiplier);

            let fixedUnitPrice = (fixedUnitPriceData != 0 && fixedUnitPriceData != null) ? fixedUnitPriceData :
              ((cost / receiveMultiplier) *
                inventoryMultiplier) *
              ((markupPercent + 1) + (markupNumber + 1));


            item.stock.extendedCost = isNaN(extendedCost) ? '' : extendedCost;
            item.stock.inventoryCost = isNaN(inventoryCost) ? '' : inventoryCost;
            if (item.stock.costInfo) {
              item.stock.costInfo.fixedUnitPriceextended = isNaN(fixedUnitPriceextended) ? '' : fixedUnitPriceextended;
              item.stock.costInfo.fixedUnitPrice = isNaN(fixedUnitPrice) ? '' : fixedUnitPrice;
            }

          }

        }

        this._items.data = data.data.value;

      } else if (this.page == "adjustInventoryHistory") {
        for (let i = 0; i < data.data.value.length; i++) {

          const item = data.data.value[i];

          if (item.stock.costInfo) {
            const fixedUnitPrice = item.stock?.costInfo?.fixedUnitPrice;
            const receiveMultiplier = item.stock?.receiveUnitOfMeasure?.multiplier;
            const inventoryMultiplier = item.stock?.inventoryUnitOfMeasure?.multiplier;
            const issueUnitOfMeasure = item.stock?.issueUnitOfMeasure?.multiplier;
            const markupPercent = item.stock?.costInfo?.markupPercent;
            const markupNumber = item.stock?.costInfo?.markupNumber;
            const newQuantity = item.newQuantity;
            const currentQuantity = item.currentQuantity;
            let quantityChange = Math.abs(newQuantity - currentQuantity);
            const cost = item.stock?.costInfo?.cost;
            let extendedCost = ((cost / receiveMultiplier) * issueUnitOfMeasure) * Math.abs(newQuantity - currentQuantity)
            let inventoryCost = ((cost / receiveMultiplier) * issueUnitOfMeasure);


            let price = fixedUnitPrice ? fixedUnitPrice : ((cost / receiveMultiplier) * inventoryMultiplier) * (1 + markupPercent ? markupPercent : 0) + (markupNumber ? markupNumber : 0);
            let extendedPrice = fixedUnitPrice ? fixedUnitPrice : ((cost / receiveMultiplier) * inventoryMultiplier) * (1 + markupPercent ? markupPercent : 0) + (markupNumber ? markupNumber : 0) * newQuantity / inventoryMultiplier;



            item.stock.costInfo.price = isNaN(price) ? 0 : price;
            item.stock.costInfo.extendedPrice = isNaN(extendedPrice) ? 0 : extendedPrice;
            item.stock.costInfo.extendedCost = isNaN(extendedCost) ? 0 : extendedCost;
            item.quantityChange = quantityChange;
            item.stock.costInfo.inventoryCost = isNaN(inventoryCost) ? 0 : extendedCost;

          }

        }

        this._items.data = data.data.value;
      } else if (this.page == 'inventories' || this.page == 'enterprise_inventories') {
        for (let i = 0; i < data.data.value.length; i++) {
          const item = data.data.value[i];
          if (item.stockItem) {
            const cost = item.stockItem?.costInfo?.cost ?? 0;
            const receiveMultiplier = item.stockItem?.receiveUnitOfMeasure?.multiplier ?? 1;
            const inventoryMultiplier = item.stockItem?.inventoryUnitOfMeasure?.multiplier ?? 1;
            const availability = item.availability ?? 0;

            let inventoryCost = (cost / (receiveMultiplier || 1)) * inventoryMultiplier;
            let extendedCost = inventoryCost * availability;

            item.stock = {
              inventoryCost: isNaN(inventoryCost) ? '' : inventoryCost,
              extendedCost: isNaN(extendedCost) ? '' : extendedCost
            };
          }
        }
        this._items.data = data.data.value;
      }

      this.resolveAndMapNestedColumns(data.data.value);
      const datepipe: DatePipe = new DatePipe('en-US');

      data.data.value.forEach((element: any) => {
        for (const k in element) {
          if (this.page == 'soApprovals') {
            //approvalLevel
            element.approvalLevel = element?.soApprovalDetails.length;

            //customers
            var customers: string = '';

            element.soApprovalSites.forEach((elem: any) => {
              elem.soCustomerApprovals.forEach((customer: any) => {
                {
                  if (!customers) {
                    customers = customers + customer.customer.code;
                  }
                  else {
                    customers = customers + ',' + customer.customer.code;
                  }
                }
              });
            });

            element.customerName = customers;

            //sites
            var sites: string = '';

            element.soApprovalSites.forEach((elem: any) => {
              if (element.soApprovalSites.indexOf(elem) == 0) {
                sites = sites + (elem.site ? elem?.site?.name : "All Sites");
              }
              else {
                sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
              }
            });

            element.soSiteName = sites;
          }

          if (this.page == 'poApprovals') {
            //approvalLevel
            element.approvalLevel = element?.poApprovalDetails.length;

            //Vendors
            var vendors: string = '';
            element.poApprovalSites.forEach((eleme: any) => {
              eleme.poVendorApprovals.forEach((vendor: any) => {
                if (vendor && vendor.vendor && vendor.vendor.code && vendor.vendor.code.length > 0) {
                  if (!vendors) {
                    vendors = vendors + vendor.vendor.code;
                  }
                  else {
                    vendors = vendors + ',' + vendor.vendor.code;
                  }
                }
              });
            });

            element.vendorName = vendors;

            //sites
            var sites: string = '';

            element.poApprovalSites.forEach((elem: any) => {
              if (element.poApprovalSites.indexOf(elem) == 0) {
                sites = sites + (elem.site ? elem?.site?.name : "All Sites");
              }
              else {
                sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
              }
            });

            element.siteName = sites;
          }

          if (this.page == 'asset-po-approvals') {
            if (k == 'approvalLevel') {
              element[k] = element?.assetPurchaseOrderApprovalDetails.length;
            }

            if (k == 'siteName') {
              var sites: string = '';

              element.assetPurchaseOrderApprovalSites.forEach((elem: any) => {
                if (element.assetPurchaseOrderApprovalSites.indexOf(elem) == 0) {
                  sites = sites + (elem.site ? elem?.site?.name : "All Sites");
                }
                else {
                  sites = sites + ',' + (elem.site ? elem?.site?.name : "All Sites");
                }
              });

              element[k] = sites;
            }

            if (k == 'vendorName') {
              var vendors: string = '';
              element.assetPurchaseOrderApprovalSites.forEach((eleme: any) => {
                eleme.assetPurchaseOrderVendorApprovals.forEach((vendor: any) => {
                  if (vendor && vendor.vendor && vendor.vendor.code && vendor.vendor.code.length > 0) {
                    if (!vendors) {
                      vendors = vendors + vendor.vendor.code;
                    }
                    else {
                      vendors = vendors + ',' + vendor.vendor.code;
                    }
                  }
                });
              });

              element[k] = vendors;
            }
          }

          if (element[k] != null && Object.keys(element[k]).length > 1) {
            if (this.dateattribute(k)) {
              element[k] = datepipe.transform(element[k], this._formatService.dateFormat);
              continue;
            }

            Object.keys(element[k]).forEach((key) => {
              if (this.dateattribute([k] + '.' + [key])) {
                element[k][key] = datepipe.transform(element[k][key], this._formatService.dateFormat);
              }
            });
          }
        }
      });

      this._customFieldsService.getEntityData(modelParam, model).pipe(map(augmentForKendo)).subscribe((customFieldsData: any) => {
        this.syncCustomFieldsDataWithDefaultData(customFieldsData, data);
        const documentCreator = new DocumentCreator();

        const doc = documentCreator.createGrid(this.headerTitle, data.data.value, this._gridColumns);
        //const doc = documentCreator.createGrid(this.headerTitle, this.testGrid.data, this._gridColumns);

        Packer.toBlob(doc).then((blob) => {
          saveAs(blob, `${this.headerTitle}.docx`);
        });
      });
    });
  }

  clickCount: number = 0;

  DoubleClickRow(event: any) {
    this.clickCount++;

    setTimeout(() => {
      if (this.clickCount === 2) {
        // double
        this.doubleClickEvent.emit(event.dataItem);
      }
      this.clickCount = 0;
    }, 250);
  }

  public rowCallback = (context: RowClassArgs) => {
    if (context && context.dataItem) {
      let classes = '';
      if (context.dataItem.availability == 0) {
        classes += 'zeroQuantity ';
      }

      if (this.rowClass) {
        const customClasses = this.rowClass(context);
        if (customClasses) {
          classes += customClasses + ' ';
        }
      }
      return classes.trim() || undefined;
    }
  }
  //#region _exportData
  _exportData = (): Observable<any> => {
    const modelParam = this._getParamModel();
    modelParam.pageSize = 999999;
    modelParam.page = 1;
    const model = { filter: {} };

    if (this._state.filter.filters.length) {
      model.filter = this._getFilterModel(true);
    }
    debugger
    return this.resolver(modelParam, model).pipe(map(augmentForKendo));
  };

  ExcelFileData: any = [];
  PDFFileData: any = [];

  public _exportPdfData(): PDFExportModule {
    const result: PDFExportModule = { data: this.PDFFileData };

    return result;
  }

  // }
  //#endregion

  //#endregion
  GetAssetPurchaseOrderStatusValue(event: any) {
    this._assetPurchaseOrderStatusValue = event;
    this.assetPurchaseOrderStatusValueEvent.emit(this._assetPurchaseOrderStatusValue);
    this.initData();
  }
  GetStockPurchaseOrderStatusValue(event: any) {
    this._stockPurchaseOrderStatusValue = event;
    this.stockPurchaseOrderStatusValueEvent.emit(this._stockPurchaseOrderStatusValue);
    this.initData();
  }
  GetStockSalesOrderStatusValue(event: any) {
    this._stockSalesOrderStatusValue = event;
    this.stockSalesOrderStatusValueEvent.emit(this._stockSalesOrderStatusValue);
    this.initData();
  }
  GetSiteTransferStatusValue(event: any) {
    this._siteTransferStatusValue = event;
    this.siteTransferStatusValueEvent.emit(this._siteTransferStatusValue);
    this._lastLoadRequestKey = '';
    this.initData(true);
  }
  GetAssetReservationValue(event: any) {
    this.assetReservationItemTypeValue = event;
    this.assetReservationValueEvent.emit(this.assetReservationItemTypeValue);
    this.initData();
  }
  GetPerformMaintenanceValue(event: any) {
    this.performMaintenanceItemTypeValue = event;
    this.performMaintenanceValueEvent.emit(this.performMaintenanceItemTypeValue);
    this.initData();
  }
  GetDisposeAuthorizationValue(event: any) {
    this.disposeAuthorizationValue = event;
    this.disposeAuthorizationValueEvent.emit(this.disposeAuthorizationValue);
    this.initData();
  }
  GetHistoryFilterValue(event: any, reloadData: boolean = true) {
    this._historyFilterValue = event?.value ?? event;
    this.historyFilterValueEvent.emit(this._historyFilterValue);
    if (reloadData) {
      this.initData(true);
    }
  }

  //#region  GetActiveMode
  GetActiveMode(event: any) {
    this._inActiveMode = event;
    this.onActiveMode.emit(this._inActiveMode);
    this._selectedItems = [];
    //this.initData();
  }

  GetClosedMode(event: any) {
    this._isClosed = event;
    this.onClosedMode.emit(this._isClosed);
    this.initData();
  }
  //#endregion

  toggleGraphvisibility(showGraph: boolean) {
    this.onGraphVisibilityChanges.emit(showGraph);
  }

  toggleGrouping(event: boolean) {
    this._groupingEnabled = event;

    if (event == false) {
      this._state.group = [];
      this.loadDefaultData();
    }
  }

  pageName: any;

  private initGrid(fromOnChanges: boolean = false) {
    setTimeout(() => {
      this._columns = this.columns.toArray();
      this._commandColumn = this._columns.find(f => f.type == 'command');
      this._columnsToShowFilterData = this._columns.map((x) => x.field && x.field);
      this._columnsToShowFilterData = this._columnsToShowFilterData.filter((x) => x != undefined);

      if (this._pdfColumns.length > 0) {
        this._pdfColumns = [];
      }

      this._gridColumns?.forEach((f, index: number) => {
        if (f.selected == true) {
          var itm: { field: string; name: string; width: number } = { field: '', name: '', width: 0 };

          itm.field = f.field;
          itm.name = f.gridFieldText?.currentText ? f.gridFieldText?.currentText : f.title + '.';
          itm.width = 300;
          this._pdfColumns.push(itm);
        }
      });

      this._paperSize = ['30in', this._pdfColumns.length + 1 + 'in'];
      this._pageScale = 0.1 * this._pdfColumns.length;
      /* alert('PageSize: '+this._paperSize);
          alert('PageScale:'+this._pageScale); */

      if (this._columns.length) {
        var selectedOrder = this._gridColumnsSelected?.find(x => x.orderedBy != null);

        this._state.sort = [
          {
            field: selectedOrder ? selectedOrder.field : this._columns[0].field,
            dir: selectedOrder ? selectedOrder.orderedBy : 'asc',
          }
        ];
      }
      // if(//!this.IsCalledAfterDataChangesSubscription
      //   //&& !this.IsCalledFromOnChanges
      //   )
      //if(!this.IsCalledFromOnChanges)
      this.initData();

      if (fromOnChanges) {
        this.IsCalledFromOnChanges = false;
      }
    });
  }

  public reloadGrid(setFirstPage: boolean = false) {
    this._lastLoadRequestKey = '';
    this.initData(setFirstPage);
  }

  private initData(setFirstPage: boolean = false, isDeleteFromGrid: boolean = false, IsCalledAfterDataChangesSubscription: boolean = false) {


    if (this.clientSidePaging == false) {
      if (this.isData) {
        if (this.data) {
          this._items = this.data;

          //this._items = this._items = { data: this.data, total: this.data.length };
        }
      }
      else {
        if (!this._gridLayoutManagerService._editColumnsActive) {
          if (this._customFieldsMode) {
            this.loadCustomFieldData(null, setFirstPage);
          }
          else {
            this.loadDefaultData(null, setFirstPage);
          }
        }
      }
    }
    else {
      if (!this._items) {
        this._items = { data: [], total: 0 };
      }

      const totalPages = Math.ceil(this._items.total / this._state.take);

      if (this._state.skip > 0 && this._state.skip === (totalPages - 1) * this._state.take && isDeleteFromGrid && this._items.data.length == 1) {
        this._state.skip -= this._state.take;
      }

      this._items = {
        data: this.data.slice(this._state.skip, this._state.skip + this._state.take),
        total: this.data.length,
      };
    }
  }

  private specialGridColumnsCalcolation() {
    this._items.data = this._items.data.map((obj: any) => ({ ...obj, quantityChange: 0 }));

    this._items.data.forEach((element: any) => {
      if (this.page == "adjustInventoryHistory")
        element.quantityChange = element.newQuantity - element.currentQuantity;
      else
        element.quantityChange = Math.abs(element.newQuantity - element.currentQuantity);


      element.stock.costInfo.price = element.stock?.costInfo?.fixedUnitPrice ? element.stock?.costInfo?.fixedUnitPrice :
        element.stock?.receiveUnitOfMeasure?.multiplier > 0 ?
          ((element.stock?.costInfo?.cost / element.stock?.receiveUnitOfMeasure?.multiplier) * element.stock?.inventoryUnitOfMeasure.multiplier) : 0
          * (1 + element.stock?.costInfo?.markupPercent ? element.stock?.costInfo?.markupPercent : 0) +
          (element.stock?.costInfo?.markupNumber ? element.stock?.costInfo?.markupNumber : 0);

      element.stock.costInfo.extendedPrice = element.stock?.costInfo?.fixedUnitPrice ? element.stock?.costInfo?.fixedUnitPrice :
        element.stock?.receiveUnitOfMeasure?.multiplier > 0 ?
          ((element.stock?.costInfo?.cost / element.stock?.receiveUnitOfMeasure?.multiplier) * element.stock?.inventoryUnitOfMeasure.multiplier) : 0
          * (1 + element.stock?.costInfo?.markupPercent ? element.stock?.costInfo?.markupPercent : 0) + (element.stock?.costInfo?.markupNumber ? element.stock?.costInfo?.markupNumber : 0)
          * element.newQuantity / element.stock?.inventoryUnitOfMeasure.multiplier;

      element.stock.costInfo.extendedCost = element.stock?.receiveUnitOfMeasure?.multiplier > 0 ? ((element.stock?.costInfo?.cost / element.stock?.receiveUnitOfMeasure?.multiplier) * element.stock?.issueUnitOfMeasure?.multiplier) : 0 *
        Math.abs(element.newQuantity - element.currentQuantity);

      element.stock.costInfo.inventoryCost = element.stock?.receiveUnitOfMeasure?.multiplier > 0 ? ((element.stock?.costInfo?.cost / element.stock?.receiveUnitOfMeasure?.multiplier) * element.stock?.issueUnitOfMeasure?.multiplier) : 0;

    });
  }

  private loadDefaultData(customFieldsData?: any, setFirstPage: boolean = false) {
    const modelParam = this._getParamModel(setFirstPage);
    const modelFilter = this.filteringEnable ? this._getFilterModel(true) : {};

    const model = {
      filter: modelFilter,
      selectedIds: this.returnedSelectedKeys,
      modelParam: modelParam,
    };

    if (this._customFieldsMode) {
      const itemIds = customFieldsData.data.map((x: any) => x.entityId).filter((v: any, i: any, a: any) => a.indexOf(v) === i);
      model.selectedIds = itemIds;
      modelParam.isCustomFieldSort = true;

      if (this._state.filter.filters.length > 0) {
        modelParam.isCustomFieldFilter = true;
      }
    }

    let requestKey = '';
    try {
      requestKey = JSON.stringify({ modelParam, model });
    } catch {
      requestKey = '';
    }

    const now = Date.now();
    if (requestKey && this._lastLoadRequestKey === requestKey) {
      if (this._isLoadingData || (now - this._lastLoadTimestamp) < 1000) {
        return;
      }
    }

    this._isLoadingData = true;
    this._lastLoadRequestKey = requestKey;
    this._lastLoadTimestamp = now;

    this.resolver(modelParam, model)
      .pipe(
        map(augmentForKendo),
        finalize(() => {
          this._isLoadingData = false;
        })
      )
      .subscribe((data: any) => {
      //this.IsCalledAfterDataChangesSubscription = false;
      data.data.value = data.data.value ?? data.data;

      this._items = { total: data.total, data: data.data.value };

      if (!this._gridColumns) {
        this._gridColumns = [];
      }

      this.pageName = this._gridColumns.map((a: any) => a.page).shift();

      switch (this.pageName) {
        case 'adjustInventoryHistory':
          this.specialGridColumnsCalcolation();
          break;

        default:
          break;
      }

      if (this.showOnlySelected) {
        this._items.data = this._items.data.filter((item: any) => {
          return this.selectedKeys.some((k) => {
            return (item.sites.some((s: any) => s.id === k.siteId) && item.id === k.accountId);
          });
        });
      }


      if (!this._customFieldsMode) {
        setTimeout(() => {
          if (this.headerEnable && (this.groupingEnabled || this.fromBarcodeLabel) && data.data.value.length) {
            this.loadCustomFieldData(data);
          }
          else {
            this.gridSetup(data);
          }
        }, 250);
      }
      else {
        this.syncCustomFieldsDataWithDefaultData(customFieldsData, data);
      }
    });
  }

  public ClearSelectedKeys(exceptId: any = 0) {
    if (exceptId && exceptId != 0) {
      this._selectedKeys = [exceptId];
      this._selectedItems = [];
    }
    else {
      this._selectedKeys = [];
      this._selectedItems = [];
    }
  }

  private loadCustomFieldData(defaultData?: any, setFirstPage: boolean = false) {
    var itemKeys = null;

    if (!this._customFieldsMode) {
      itemKeys = defaultData.data.value.map((x: any) => x.id);
    }

    const modelParam = this._getParamModel(setFirstPage);
    const modelFilter = this.filteringEnable ? this._getFilterModel() : {};

    let model: any = {
      filter: modelFilter,
      entityIds: itemKeys,
      entity: this.entityName,
      page: this.page,
    };

    if (this._customFieldsMode) {
      model['selectedField'] = this._customFieldChanged;
      modelParam.orderBy = 'value';
    }
    this._customFieldsService.getEntityData(modelParam, model).pipe(map(augmentForKendo)).subscribe((data: any) => {
      if (this._customFieldsMode) {
        this.loadDefaultData(data);
      }
      else {
        this.syncCustomFieldsDataWithDefaultData(data, defaultData);
      }
    });
  }

  private syncCustomFieldsDataWithDefaultData(customFeildsData: any, defaultData: any, exportpdft: boolean = false) {
    let counter = 0;

    customFeildsData.data.forEach((element: any) => {
      let item = defaultData.data.value.find((x: any) => x.id == element.entityId);

      if (item) {
        item[element.customField.name] = element.value;
        //=======================Customer Date Format to Excle sheet===============================
        if (element.customFields !== undefined && element.customFields.customFieldType.id === 3) {
          const datepipe: DatePipe = new DatePipe('en-US');
          //  let formattedDate = new Date ( datepipe.transform(element.value, this._formatService.dateFormat))
          //  let df = this.dateFormatPipeFilter.transform(element.value, this._formatService.dateFormat)
          // datepipe.transform(element.value, this._formatService.dateFormat)
          try {
            item[element.customField.name] = datepipe.transform(element.value, this._formatService.dateFormat); // ; exportpdft ? formattedDate : formattedDate.toLocaleDateString()
          }
          catch {
            item[element.customField.name] = element.value;
          }
        }

        ///=========================================================================================
        // if order by a custom field
        if (this._customFieldInSorting) {
          if (!item.$order) {
            (item as any).$order = ++counter;
          }
        }
      }
    });

    // if order by a custom field
    if (this._customFieldInSorting) {
      defaultData.data.value = defaultData.data.value.sort((n1: any, n2: any) => n1.$order - n2.$order);
    }

    this.gridSetup(defaultData);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    let topHeight = this.gridHeaderWrapper?.nativeElement.clientHeight + 105;
    this._maxHeight = document.body.clientHeight - topHeight;
    // your logic here
  }

  private gridSetup(data: any) {
    let topHeight = this.gridHeaderWrapper?.nativeElement.clientHeight + 105;
    this._maxHeight = document.body.clientHeight - topHeight;

    if (this._state.group.length) {
      this._items = process(this._items.data, { group: this._state.group });
      this._items.total = data.total;
    }

    // set _selectedKeys for grid checkbox
    this._selectedKeys = [];

    this.selectedKeys.forEach((x) => {
      this._selectedKeys.push(x);
    });

    setTimeout(() => {
      this._initScrollable();
    });
  }

  _onColumnReorder(event: any) {
    let model = {
      page: this.page,
      field: event.column.field,
      index: event.newIndex,
      oldIndex: event.oldIndex,
    };

    this._gridFields.updateGridFieldOrder(model).subscribe(() => {
      // this.initGrid();
    });
  }

  _onColumnSort(event: any) {
    let model = {
      page: this.page,
      field: event[0].field,
      sortBy: event[0].dir
    };

    this._gridFields.updateGridFieldSort(model).subscribe(() => { });
  }

  _initScrollable() {
    // if (this.gridWrapper?.nativeElement.clientHeight >= this._maxHeight) {
    //   this._scrollable = true;
    // } else {
    this._scrollable = true;
    //}
  }

  _onSearch(text: string) {
    if (text && text.length > 0) {
      this.isSearchMode = true;
    }
    else {
      this.isSearchMode = false;
    }

    this._searchQuery = text;
    this.initData(true);
  }

  _refreshButtonClicked(event: any) {
    this._searchQuery = '';
    this.isSearchMode = false;
    //  if(
    //   (!this.IsCalledFromOnChanges
    //     && !this.addNewFormEnabled))
    // {
    //this.initData(true);
    // }

  }

  _viewActiveInActiveClicked(event: any) {
    this._searchQuery = '';
    this.isSearchMode = false;
    //this.onActiveMode.emit(this._inActiveMode);
    //this.initData();
    // this._selectedItems = [];
    // this.initData();
  }

  GetByAssetPurchaseOrdersStatusId(assetPurchaseOrderStatusId: any) {
    this.assetPurchaseOrderStatusId = assetPurchaseOrderStatusId;
    this.initData(true);
  }

  pushItemsToList(items: any[], selectedItemListInsideGroup: any[]): void {
    items.forEach(item => {
      if (Array.isArray(item.items) && item.items.length > 0) {
        this.pushItemsToList(item.items, selectedItemListInsideGroup);
      }
      else {
        selectedItemListInsideGroup.push(item);
      }
    });
  }

  _onSelectedKeysChange(selectedItems: any, itemslist: any) {
    var selectedItemListInsideGroup: any = [];

    if (this._state.group && this._state.group.length > 0) {
      itemslist.data.forEach((element: any) => {
        this.pushItemsToList(element.items, selectedItemListInsideGroup);
      });
    }

    let selectedList = selectedItems;

    this.onRowSelectionChanges.emit(selectedList);
    //====================GET DIFF BETWEEN _selectedItems AND selectedList THEN REMOVE ITEMS FROM _selectedItems =============
    //  let selectedItemsindex = this._selectedItems.map((element:any,rowindex:any) =>{return rowindex})
    //  let difference = selectedItemsindex.filter(x => !selectedList.includes(x));

    this._selectedItems = [];

    selectedList.forEach((element: any, index: number) => {
      if (this._state.group && this._state.group.length > 0) // Is Grouped By Column
      {
        if (this.selectByField) {
          var _res = selectedItemListInsideGroup.filter((e: any, ind: any) => e[this.selectByField] == element).shift();

          if (_res !== undefined && _res !== null) {
            this._selectedItems.push(_res);
          }
        }
        else {
          var _res = selectedItemListInsideGroup.filter((e: any, ind: any) => (ind + (this._state.skip || 0)) == element).shift();

          if (_res !== undefined && _res !== null) {
            this._selectedItems.push(_res);
          }
        }
      }
      else {
        if (this.selectByField) {
          //if (itemslist && !itemslist.data) {
          //  itemslist.data = itemslist;
          //}

          var _res = itemslist.data.filter((e: any, ind: any) => e[this.selectByField] == element).shift();

          if (_res !== undefined && _res !== null) {
            this._selectedItems.push(_res);
          }
        }
        else {
          var _res = itemslist.data.filter((e: any, ind: any) => (ind + (this._state.skip || 0)) == element).shift();

          if (_res !== undefined && _res !== null) {
            this._selectedItems.push(_res);
          }
        }
      }
    });


    // if(difference.length > 0 && selectedList.length > 0) {
    //   this._selectedItems = [...itemslist.data] ;
    //     difference.forEach((element: any, index: number) => {
    //       this._selectedItems.splice(element, 1);
    //     });
    //   }
    //=============================================================================================
    this._selectedChangeList = selectedList;
  }


  _dataStateChange(event: DataStateChangeEvent): void {
    const stateHasChanged =
      this._state.skip !== event.skip ||
      this._state.take !== event.take ||
      JSON.stringify(this._state.sort) !== JSON.stringify(event.sort) ||
      JSON.stringify(this._state.filter) !== JSON.stringify(event.filter) ||
      JSON.stringify(this._state.group) !== JSON.stringify(event.group);

    if (!stateHasChanged) {
      return;
    }

    const sortChanged = JSON.stringify(this._state.sort) !== JSON.stringify(event.sort);
    if (sortChanged && event.sort && event.sort.length > 0 && event.sort[0].field) {
      let model = {
        page: this.page,
        field: event.sort[0].field,
        sortBy: event.sort[0].dir
      };
      this._gridFields.updateGridFieldSort(model).subscribe(() => { });
    }

    this._state = event;
    this._sharedService.setPageSize(this._currentUser.id, this.pageName, this._state.take.toString())

    if (event.sort && event.sort.length > 0 && event.sort[0].field && this.isCustomField(event.sort[0].field)) {
      this._customFieldInSorting = true;
    }
    else {
      this._customFieldInSorting = false;
    }

    if (this._state.filter.filters.length) {
      this._state.filter.filters.forEach(
        (columnFilter: CompositeFilterDescriptor) => {
          columnFilter.filters.forEach((filter: any) => {
            // check if custom field
            if (this.isCustomField(filter.field.toString())) {
              this._customFieldInFilter = true;
            }
            //
          });
        }
      );
    }

    this.isCustomFieldMode();
    this.initData();
  }

  _filterStateChange(filter: any) {
    const event: DataStateChangeEvent = {
      skip: this._state.skip,
      take: this._state.take,
      sort: this._state.sort,
      group: this._state.group,
      filter: this._state.filter,
    };

    const filterIndex = event.filter.filters.findIndex((x: CompositeFilterDescriptor) =>
      x.filters.find((x: FilterDescriptor) => x.field === filter.field));

    const filterData: any = {
      logic: 'or',
      filters: filter.value.map((x: any) => {
        return {
          field: filter.field,
          value: x,
          operator: 'eq',
        };
      })
    };

    if (filterIndex > -1) {
      event.filter.filters[filterIndex] = filterData;
    }
    else {
      event.filter.filters.push(filterData);
    }

    this._dataStateChange(event);
  }

  _selectedAccountChanged(rowIndex: any, accountCheckbox: any) {
    if (accountCheckbox.target.checked) {
      setTimeout(() => {
        this.siteCombobox['_results'][parseInt(rowIndex)]?.toggle(true);
        this.siteCombobox['_results'][parseInt(rowIndex)]?.focus();
      });
    }
  }

  public isCustomField(field: string) {
    if (this._gridColumns != null && this._gridColumns?.find((x) => x.isCustomField && x.field === field)) {
      this._customFieldChanged = field;

      return true;
    }
    else {
      return false;
    }
  }

  private isCustomFieldMode() {
    if (this._customFieldInSorting || this._customFieldInFilter) {
      this._customFieldsMode = true;
    }
    else {
      if (this.isPDF && this.page == 'stockItems') {
        this._customFieldsMode = true;
      } else {
        this._customFieldsMode = false;
      }
      this._customFieldChanged = null;
    }
  }

  private _getParamModel(setFirstPage: boolean = false): any {
    if (setFirstPage) {
      this._state.skip = 0;
      //this._state.take = 50;
    }

    const model = {
      page: (this.isSearchMode && setFirstPage) || this._deleted ? 1 : this._state.skip / this._state.take + 1,
      pageSize: this._state.take,
      search: this._searchQuery,
      orderBy: this._state && this._state.sort[0] ? this._state.sort[0].field : '',
      orderByMethod: this._state && this._state.sort[0] ? this._state.sort[0].dir : '',
      deleted: this._inActiveMode.toString(),
      isClosed: this.page == 'pickList' ? this._isClosed.toString() : null,
      stockPurchaseOrderStatusId: this.page == 'purchaseOrders' && !this._inActiveMode
        ? this._stockPurchaseOrderStatusValue?.toString()
        : null,
      stockSalesOrderStatusId: this.page == 'salesOrders' && !this._inActiveMode
        ? this._stockSalesOrderStatusValue?.toString()
        : null,
      siteTransferStatusId: (this.page == 'siteTransfers' || this.page == 'site-transfers') && !this._inActiveMode
        ? this._siteTransferStatusValue?.toString()
        : null,
      assetPurchaseOrderStatusId: this.page == 'asset-purchaseOrders' && !this._inActiveMode
        ? this._assetPurchaseOrderStatusValue?.toString()
        : null,
      assetReservationItemTypeId: this.page == 'asset-reservation' && !this._inActiveMode
        ? this.assetReservationItemTypeValue?.toString()
        : null,
      historyFilter: (this.page == 'history' || this.page == 'asset-all-history' || this.isHistoryPage) && this._historyFilterValue
        ? (this._historyFilterValue?.value ?? this._historyFilterValue).toString()
        : null,
    };

    if (model.orderByMethod == undefined) {
      model.orderByMethod = 'asc';
    }

    if (!model.orderByMethod) {
      delete model.orderBy;
    }
    else {
      // fix orderby if the field is an object
      if (model.orderBy) {
        const sortingField = model.orderBy.split('.');

        if (sortingField.length) {
          // model.orderBy = sortingField[0];
        }

        if (model.orderBy === 'personNameFirstLast') {
          model.orderBy = 'person.firstName';
        }

        if (this.page == 'users') {
          // users page
          if (model.orderBy == 'fullName' || model.orderBy == 'person.firstName') {
            model.orderBy = 'firstName+lastName';
          }
        }
      }
    }

    if (!this.pagingEnabled) delete model.page;
    if (!this.pagingEnabled) delete model.pageSize;
    if (!this._searchEnabled) delete model.search;
    if (!this.sortingEnabled) delete model.orderBy;
    if (!this.sortingEnabled) delete model.orderByMethod;

    return model;
  }

  private _getFilterModel(fromDefaultLoading?: boolean): any {
    const model: any = { where: { operatorType: treeFilterMapOptions['and'], operands: [] } };

    let isCustomField: boolean;
    this._customFieldInFilter = false;

    if (this._state.filter.filters.length) {
      this._state.filter.filters.forEach((columnFilter: CompositeFilterDescriptor) => {
        // fill operation for each column
        let cloumnFilters: TreeFilter[] = [];
        isCustomField = false;

        columnFilter.filters.forEach((filter: any) => {
          // check if custom field
          if (this.isCustomField(filter.field.toString())) {
            isCustomField = true;
          }
          // Map virtual fields to actual entity paths
          let filterField = filter.field.toString();
          if (filterField === 'personNameFirstLast') {
            filterField = 'person.firstName';
          }
          cloumnFilters.push({
            field: isCustomField ? 'value' : filterField,
            customFieldName: isCustomField ? filter.field.toString() : null,
            filterType: whereFilterMapOptions[filter.operator],
            value: filter.value,
          });
        });

        if ((!isCustomField && fromDefaultLoading) || (isCustomField && !fromDefaultLoading)) {
          model.where.operands.push({ operatorType: treeFilterMapOptions[columnFilter.logic], operands: cloumnFilters });
        }
      });
    }
    else {
      return {};
    }

    if (!model.where.operands.length) {
      return {};
    }

    return model;
  }

  public fitColumns(count: number): void {
    //this.initGrid()
    this._ngZone.onStable.asObservable().pipe(take(count)).subscribe(() => {
      this.grid.resetGroupsState(); //autoFitColumns
    });
  }

  public pageChange(event: any): void {
    let pad = this.grid.selection;
    this.onRowObjectSelectionindexList.emit(pad);
  }

  _onSelectionChange(event: SelectionEvent) {
    if (event.deselectedRows.length > 0) {
      event.deselectedRows.forEach((deselectedElement: RowArgs) => {
        if (this._selectedItems.length > 0) {
          this._selectedItems.forEach((element: any, index: number) => {
            if (this.selectByField) {
              if (element[this.selectByField] === deselectedElement.dataItem[this.selectByField]) {
                this._selectedItems.splice(index, 1);
              }
            }
            else {
              if (element.id === deselectedElement.dataItem.id) {
                this._selectedItems.splice(index, 1);
              }
            }
          });
        }
      });
    }

    if (event.selectedRows.length > 0) {
      event.selectedRows.forEach((element: RowArgs) => {
        //this._selectedItems.push(element.dataItem);
      });
    }
    this.onRowObjectSelectionChanges.emit(this._selectedItems);
  }

  _filterDataChecked(show: boolean, field: string) {
    if (!show) {
      this._columnsToShowFilterData.splice(this._columnsToShowFilterData.indexOf(field), 1);
    }
  }

  _showColumnFilterData(field: string) {
    if (this._columnsToShowFilterData != undefined)
      return this._columnsToShowFilterData.indexOf(field) != -1;
  }

  resolveAndMapNestedColumns(items: any[]) {
    if (!items || !items.length || !this._gridColumns) {
      return;
    }
    const columnsWithDots = this._gridColumns.filter(c => c.field && c.field.includes('.'));
    if (!columnsWithDots.length) {
      return;
    }

    items.forEach(item => {
      columnsWithDots.forEach(col => {
        const parts = col.field.split('.');
        let val: any = item;
        for (let i = 0; i < parts.length; i++) {
          if (val === null || val === undefined) {
            val = null;
            break;
          }
          let next = val[parts[i]];
          if (Array.isArray(next)) {
            next = next[0];
          }
          val = next;
        }

        if (parts.length === 3) {
          let base = item[parts[0]];
          if (base) {
            if (Array.isArray(base)) {
              base = base[0];
            }
            if (base) {
              if (col.field === 'user.person.code') {
                val = base.userCode;
              } else {
                if (parts[1] === 'itemType' && parts[2] === 'code' && !val) {
                  let itemTypeObj = base[parts[1]] ? (Array.isArray(base[parts[1]]) ? base[parts[1]][0] : base[parts[1]]) : null;
                  val = itemTypeObj ? (itemTypeObj.name ?? itemTypeObj.description) : '';
                }
                if (parts[1] === 'costInfo' && parts[2] === 'cost' && !val) {
                  if (base['costInfo']) {
                    val = base['costInfo']['cost'] ?? null;
                  }
                }
                if (parts[1] === 'inventoryUnitOfMeasure' && parts[2] === 'symbol' && !val) {
                  if (base['inventoryUnitOfMeasure']) {
                    val = base['inventoryUnitOfMeasure']['symbol'] ?? null;
                  }
                }
                if (parts[1] === 'receiveUnitOfMeasure' && parts[2] === 'symbol' && !val) {
                  if (base['receiveUnitOfMeasure']) {
                    val = base['receiveUnitOfMeasure']['symbol'] ?? null;
                  }
                }
              }
            }
          }
        }

        if (parts.length === 2) {
          if (parts[0] === 'itemType' && parts[1] === 'code' && !val) {
            let itemTypeObj = item[parts[0]] ? (Array.isArray(item[parts[0]]) ? item[parts[0]][0] : item[parts[0]]) : null;
            val = itemTypeObj ? (itemTypeObj.name ?? itemTypeObj.description) : '';
          }
        }

        if (val !== null && val !== undefined) {
          // 1. Set as flat key
          item[col.field] = val;

          // 2. Set as nested path
          let current = item;
          for (let i = 0; i < parts.length - 1; i++) {
            const part = parts[i];
            if (!current[part]) {
              current[part] = {};
            }
            current = current[part];
          }
          current[parts[parts.length - 1]] = val;
        }
      });
    });
  }

  getFirstGroupItem(group: any): any {
    if (!group) return null;
    if (Array.isArray(group.items) && group.items.length > 0) {
      let item = group.items[0];
      while (item && item.items && Array.isArray(item.items) && item.items.length > 0) {
        item = item.items[0];
      }
      return item;
    }
    return group;
  }
}
